import React, { FC } from "react";

interface HeaderProps {
  heading: string;
}

const Header: FC<HeaderProps> = ({ heading }) => {
  return (
    <div className="py-[22px] px-4 bg-gray-400 border-b border-gray-100">
      <p className="uppercase font-semibold text-secondary text-sm leading-none">
        {heading}
      </p>
    </div>
  );
};

export default Header;
